import {
  Box,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  inputBaseClasses,
  outlinedInputClasses,
  paginationItemClasses,
  selectClasses,
  styled,
} from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const PaginationControls = styled(Pagination)({
  [`& .${paginationItemClasses.ellipsis}`]: {
    color: '#717184',
  },
  [`& .${paginationItemClasses.root}`]: {
    borderRadius: 8,
    margin: '0 6px',
  },
  [`& .${paginationItemClasses.previousNext}`]: {
    border: '1px solid #C8C8D0',
  },

  [`& .${paginationItemClasses.page}:not(.Mui-selected)`]: {
    color: '#717184',
  },
});

const RowsPerPageSelect = styled(Select)({
  width: 100,
  [`& .${selectClasses.select}.${selectClasses.outlined}.${inputBaseClasses.input}.${outlinedInputClasses.input}`]: {
    padding: '10px 16px',
    fontSize: 14,
  },
});

const RowsPerPageLabel = styled(InputLabel)({
  color: '#717184',
  margin: 0,
  fontSize: 14,
});

const TablePagination = ({
  totalPages,
  onPageChange,
  page,
  start,
  end,
  total,
  rowsPerPage,
  rowsPerPageOptions,
  handleChangeRowsPerPage,
  className,
  sx,
  paginationDisabled,
}) => {
  const onRowsPerPageChange = (...args) => {
    handleChangeRowsPerPage(...args);
    onPageChange(null, 1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 30px',
        '@media print': {
          display: 'none',
          ...sx?.['@media print'],
        },
        ...sx,
      }}
      className={classNames('print:hidden', className)}
    >
      <span className='text-[#717184] text-[14px] flex-1'>
        Showing {Math.min(start, end)} to {end} of {total}
      </span>
      <PaginationControls
        disabled={paginationDisabled}
        className='flex-1 flex justify-center basis-[40%]'
        color='primary'
        shape='rounded'
        count={totalPages}
        onChange={onPageChange}
        page={page}
      />
      <div className='flex items-center justify-end flex-1 gap-[16px]'>
        <RowsPerPageLabel id='show-rows-count-label'>Show</RowsPerPageLabel>
        <RowsPerPageSelect
          labelId='show-rows-count-label'
          id='show-rows-count'
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
        >
          {rowsPerPageOptions.map(option => (
            <MenuItem value={option} key={option}>
              {option} rows
            </MenuItem>
          ))}
        </RowsPerPageSelect>
      </div>
    </Box>
  );
};

TablePagination.propTypes = {
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  start: PropTypes.number,
  end: PropTypes.number,
  total: PropTypes.number,
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
  handleChangeRowsPerPage: PropTypes.func,
  className: PropTypes.string,
  sx: PropTypes.object,
  paginationDisabled: PropTypes.bool,
};

export default TablePagination;
